import { render } from "./QCheckbox.vue?vue&type=template&id=cb189c0a&scoped=true"
import script from "./QCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./QCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./QCheckbox.vue?vue&type=style&index=0&id=cb189c0a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb189c0a"],['__file',"src/components/UI/buttons/QCheckbox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb189c0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb189c0a', __exports__)) {
    api.reload('cb189c0a', __exports__)
  }
  
  module.hot.accept("./QCheckbox.vue?vue&type=template&id=cb189c0a&scoped=true", () => {
    api.rerender('cb189c0a', render)
  })

}


export default __exports__